module.exports = __webpack_public_path__ + "static/quartier_J-834895be3ebeaae61d73a04203d744b9.png";